import { render, staticRenderFns } from "./Slug.vue?vue&type=template&id=2f567b79&"
import script from "./Slug.vue?vue&type=script&lang=js&"
export * from "./Slug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports